interface TreelLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
};

export default function TreelLogo({ size = 'md', className = '' }: TreelLogoProps) {
  const logoSize = sizeMap[size];

  return (
    <svg 
      width={logoSize} 
      height={logoSize} 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={`flex-shrink-0 ${className}`}
    >
      <mask id={`mask0_12449_31769_${size}`} style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="6" y="6" width="52" height="52">
        <rect x="6" y="6" width="52" height="52" fill="white"/>
      </mask>
      <g mask={`url(#mask0_12449_31769_${size})`}>
        <path d="M34.052 12.6461C33.5643 10.4513 30.4357 10.4513 29.948 12.6461L28.6594 18.445C27.5262 23.544 23.544 27.5262 18.445 28.6594L12.6461 29.948C10.4513 30.4357 10.4513 33.5643 12.6461 34.052L18.445 35.3406C23.544 36.4738 27.5262 40.456 28.6594 45.555L29.948 51.3539C30.4357 53.5487 33.5643 53.5487 34.052 51.3539L35.3406 45.555C36.4738 40.456 40.456 36.4738 45.555 35.3406L51.3539 34.052C53.5487 33.5643 53.5487 30.4357 51.3539 29.948L45.555 28.6594C40.456 27.5262 36.4738 23.544 35.3406 18.445L34.052 12.6461Z" fill="#D92B82"/>
        <path d="M34.052 12.6461C33.5643 10.4513 30.4357 10.4513 29.948 12.6461L28.6594 18.445C27.5262 23.544 23.544 27.5262 18.445 28.6594L12.6461 29.948C10.4513 30.4357 10.4513 33.5643 12.6461 34.052L18.445 35.3406C23.544 36.4738 27.5262 40.456 28.6594 45.555L29.948 51.3539C30.4357 53.5487 33.5643 53.5487 34.052 51.3539L35.3406 45.555C36.4738 40.456 40.456 36.4738 45.555 35.3406L51.3539 34.052C53.5487 33.5643 53.5487 30.4357 51.3539 29.948L45.555 28.6594C40.456 27.5262 36.4738 23.544 35.3406 18.445L34.052 12.6461Z" fill={`url(#paint0_radial_12449_31769_${size})`}/>
        <path d="M34.052 12.6461C33.5643 10.4513 30.4357 10.4513 29.948 12.6461L28.6594 18.445C27.5262 23.544 23.544 27.5262 18.445 28.6594L12.6461 29.948C10.4513 30.4357 10.4513 33.5643 12.6461 34.052L18.445 35.3406C23.544 36.4738 27.5262 40.456 28.6594 45.555L29.948 51.3539C30.4357 53.5487 33.5643 53.5487 34.052 51.3539L35.3406 45.555C36.4738 40.456 40.456 36.4738 45.555 35.3406L51.3539 34.052C53.5487 33.5643 53.5487 30.4357 51.3539 29.948L45.555 28.6594C40.456 27.5262 36.4738 23.544 35.3406 18.445L34.052 12.6461Z" fill={`url(#paint1_radial_12449_31769_${size})`}/>
      </g>
      <defs>
        <radialGradient id={`paint0_radial_12449_31769_${size}`} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11 53.0411) rotate(-45.056) scale(29.7276)">
          <stop offset="0.65" stopColor="#FF9F80"/>
          <stop offset="1" stopColor="#D92B82" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id={`paint1_radial_12449_31769_${size}`} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(53.0411 11) rotate(135.891) scale(29.7311)">
          <stop offset="0.65" stopColor="#FF80EA"/>
          <stop offset="1" stopColor="#D92B82" stopOpacity="0"/>
        </radialGradient>
      </defs>
    </svg>
  );
}